import React, {ReactElement} from 'react';
import close from '@assets/images/medops/close.svg';
const Close = (props: any): ReactElement => {
  return <img src={close} height={28} width={28} {...props} />;
};
export default Close;
